import { SettingsForm } from '@pages/settings/settings-form/settings-form'
import { ChildProfileSettings } from './child-profile-settings'
import { useActiveProfileInfo } from '@entities/profile/lib/use-active-profile-info'

// Раздел «Профиль» в настройках: в детском режиме ребёнок редактирует
// свой профиль (имя, дата рождения, аватар, инструменты), в родительском —
// настройки аккаунта (SettingsForm).
export const ProfileSettings = () => {
	const { isChildMode } = useActiveProfileInfo()

	return isChildMode ? <ChildProfileSettings /> : <SettingsForm />
}
